import { HttpClient } from '@angular/common/http';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { ProgramListItemActionButtonConfiguration } from '@shared/components/program-list-item/program-list-item.component';
import { ProgramTemplate, ProgramTemplateData } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { ProgramTemplatePreviewDialogComponent } from './program-template-preview/program-template-preview-dialog.component';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { Router } from '@angular/router';
import { UIState } from '@shared/directives/ui-state/ui-state.directive';
import { InternalAnalyticsService, IntercomTags } from '@shared/services/internalAnalytics.service';

@Component({
  selector: 'program-template-picker-dialog',
  templateUrl: './program-template-picker-dialog.component.html',
  styleUrls: ['./program-template-picker-dialog.component.scss']
})
export class ProgramTemplatePickerDialogComponent implements OnInit {
  errorMessage = 'Oops, something went wrong. Please retry later.';
  state = UIState.default;
  templates: ProgramTemplate[];
  
  constructor(
    private _courseApiService: CoursesAPIService,
    private _currentHubService: CurrentHubService,
    private _http: HttpClient,
    private _dialog: MatDialog,
    protected _router: Router,
    private _internalAnalitycsService: InternalAnalyticsService
  ) {}

  async ngOnInit() {
    try {
      this.state = UIState.inprogress;
      
      const templateData = await this._http.get<ProgramTemplateData>(environment.programsTemplateFile).toPromise();
      const templates = templateData.templates.filter(t => !t.hidden);

      // Populate attributes for each template with values from the actual program.
      this.templates = await Promise.all(templates.map(async (template) => {
        const program = await this._courseApiService.getLearnspaceById(template.program_id, true).toPromise();
        template.title ||= program.title;
        template.description ||= program.description;
        template.thumbnail ||= program.postermedia?.path;
        template.experienceCount = program.courses?.length || 0;
        return template;
      }));

      this.state = UIState.default;
    } catch (error) {
      this.state = UIState.error;
    }
  }

  getActionButtons(template: ProgramTemplate, forceUseAction = false): ProgramListItemActionButtonConfiguration[] {
    return template.experienceCount > 0 && !forceUseAction
      ? [{ label: "Explore this template", action: () => this.exploreTemplate(template) }]
      : [{ label: "Use this template", action: async () => await this.useTemplate(template) }]
  }

  exploreTemplate(template: ProgramTemplate) {
    this._dialog.open(ProgramTemplatePreviewDialogComponent, {
      backdropClass: 'click-through-dialog-backdrop',
      panelClass: ['fullscreen-dialog', 'programs-image-background'],
      data: { template, actionButtons: this.getActionButtons(template, true) }
    });
  }

  async useTemplate(template: ProgramTemplate) {
    const newProgram = await this._courseApiService.duplicateLearnspace(template.program_id, this._currentHubService.hub.id).toPromise();
    this._internalAnalitycsService.addIntercomUserTag(IntercomTags.WONDA_PRO_HAS_CREATED_PROGRAM);
    this._router.navigate([`${this._currentHubService.getHubURLTitle()}/${newProgram.id}`]);
    this._dialog.closeAll();
  }
}
